import shortID from '../../../utils/shortID';
import { ProcessingNode } from '../../defs';

export default {
    create: () => new ProcessingNode({
        id: shortID(),
        type: "swapInputs",
        inputs: [{
            id: shortID(),
            name: "input1",
            type: "any"
        }, {
            id: shortID(),
            name: "input2",
            type: "any"
        }, {
            id: shortID(),
            name: "swap",
            type: "boolean"
        }],
        outputs: [{
            id: shortID(),
            name: "output",
            type: "any"
        }, {
            id: shortID(),
            name: "output",
            type: "any"
        }],
    }),
    process: (input: any[], nodeId : string, processedByLiveScreen : boolean) => {
        if(!input) return [null];
        if(input.length === 1){
            return [input[0]];
        }
        if(input[0] === null || input[0] === undefined){
            return [input[1]];
        }

        if(input[2]){
            return [input[1], input[0]];
        }
        return [input[0], input[1]];
    },
}
